import { render, staticRenderFns } from "./AditionalsAccountsReceivable.vue?vue&type=template&id=54761b73&scoped=true"
import script from "./AditionalsAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./AditionalsAccountsReceivable.vue?vue&type=script&lang=js"
import style0 from "./AditionalsAccountsReceivable.vue?vue&type=style&index=0&id=54761b73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54761b73",
  null
  
)

export default component.exports